export default function setTransparency(color, alpha) {
  if (color === null || color === undefined) {
    return color
  }

  if (color.length !== 9) {
    return color
  }

  const value = color.substring(0, 7)
  return `${value}${alpha}`
}
